import React, { Fragment, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom'
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Container, Row, Col, Table, FormGroup, Button, Label, Input, Alert, ListGroup, ListGroupItem } from 'reactstrap';
import { ContentAbout0, ContentAbout1, ContentAbout2, ContentAbout3, ContentAbout4 } from '../Blocks/_ContentBlocks';
import { TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faSave, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import TShirt from './../Resources/Images/TShirt.jpg';
import CompsAPI from '../Shared/DataCompAPI';


export const RecordLeaderBoard = (props) => {

    const [blockName, setBlockName] = useState("");

    const [comp, setComp] = useState("");
    const [year, setYear] = useState("2026");
    const [puckoEntries, setPuckoEntries] = useState([]);
    const [speciesEntries, setSpeciesEntries] = useState([]);

    useEffect(() => {
        CompsAPI.getPucko({}, puckoCallback);
        CompsAPI.getSpecies({}, speciesCallback);
    }, []);

    let puckoCallback = (data) => {
        setPuckoEntries(data);
    };

    let speciesCallback = (data) => {
        setSpeciesEntries(data);
    };

    return (
        <Block name="Records" isAlt={false}>
            <TextHeader 
                text={"Sanc Souci Dolphins Competition Leaderboard"}
            />

            <TextTitle
                text={<a href="SubmitRecord">Submit your record here</a>}
            />

            <Row>
                <Col>
                    <h2>Pucko Challenge</h2>
                    <Table striped hover borderless>
                        <thead>
                            <tr>
                                <th>
                                    Position #
                                </th>
                                <th>
                                    Diver
                                </th>
                                <th>
                                    Fish
                                </th>
                                <th>
                                    Weight
                                </th>
                                <th>
                                    Length
                                </th>
                                <th>
                                    Caught
                                </th>
                                <th>
                                    Photos
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {puckoEntries.map((entry, entryIndex) =>
                                <tr key={entryIndex}>
                                    <td>
                                        <span>{entryIndex + 1}</span>
                                    </td>
                                    <td>
                                        <span>{entry.diver}</span>
                                    </td>
                                    <td>
                                        <span>{entry.fishPelagic}</span>
                                    </td>
                                    <td>
                                        <span>{entry.weight}</span>
                                    </td>
                                    <td>
                                        <span>{entry.length}</span>
                                    </td>
                                    <td>
                                        <span>{entry.caught}</span>
                                    </td>
                                    <td>
                                        <span></span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Row>
                <Col>
                    <h2>Club Species Comp</h2>
                    <Table hover borderless >
                        <thead>
                            <tr>
                                <th>
                                    Species
                                </th>
                                <th>
                                    Diver
                                </th>
                                <th>
                                    Weight
                                </th>
                                <th>
                                    Length
                                </th>
                                <th>
                                    Caught
                                </th>
                                <th>
                                    Photos
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {speciesEntries.map((entry, entryIndex) =>
                                <tr key={entryIndex}>
                                    <td>
                                        <span>{entry.fishSpecies}</span>
                                    </td>
                                    <td>
                                        <span>{entry.diver}</span>
                                    </td>
                                    <td>
                                        <span>{entry.weight}</span>
                                    </td>
                                    <td>
                                        <span>{entry.length}</span>
                                    </td>
                                    <td>
                                        <span>{entry.caught}</span>
                                    </td>
                                    <td>
                                        <span></span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>


        </Block>
    );
}
